import React from "react";
import "./Footer.css";
// import Logo from "../../public/images/logo.jpeg";
import { FaInstagram, FaSquareXTwitter } from "react-icons/fa6";
import { FaFacebookSquare, FaLinkedin } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { Link } from "react-router-dom";

const Footer = () => {
  const columnData = [
    {
      heading: "Navigation",
      items: [
        { label: "Services", url: "/services" },
        { label: "Docs", url: "/docs/getting-started" },
        { label: "Contact Us", url: "/contact-us" },
        { label: "Pricing Plans", url: "/pricing-plans" },
      ],
    },
    {
      heading: "Support",
      items: [
        {
          label: "Co-financed by the European Union",
          url: "/informativa_privacy",
        },
        { label: "Privacy Policy", url: "/privacy-policy" },
        { label: "Terms and Conditions of Use", url: "/terms&conditons" },
        { label: "Cookie Policy", url: "/cookie-policy" },
        {
          label: "Privacy Roles and Responsibilities Document",
          url: "/privacy-roles&responsibilities",
        },
      ],
    },
    {
      heading: "TODO AI",
      items: [
        { label: "VAT number: 09781131215", url: "#" },
        { label: "Telefono: +3908118920052", url: "#" },
        { label: "support@todoai.ai", url: "mailto:support@todoai.ai" },
      ],
    },
  ];

  return (
    <div className="footer-background">
      <section className="container-xmedium footer-section">
        {/* First Column (Logo & Description) */}
        <div className="footer-col footer-col-1">
          <img
            src="/images/logo todo 1.png"
            alt="Logo"
            className="footer-logo"
          />
          <p>
            Artificial Intelligence Redefining the Future of Health, Beauty and
            Wellness
          </p>
        </div>

        {/* Other Columns */}
        {columnData.map((col, index) => (
          <div className="footer-col footer-col-other" key={index}>
            <h4>{col.heading}</h4>
            <ul>
              {col.items.map((item, idx) => (
                <li key={idx}>
                  <Link to={item.url}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>
      <section className="container-xmedium">
        <hr></hr>
        <div className="footer-end">
          <div>{new Date().getFullYear()} Todo Ai. All rights reserved.</div>

          <div className="icons-gap">
            <a
              href="https://www.facebook.com/share/16phs4wjHX/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookSquare color="white" />
            </a>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/todo-group-s-r-l/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin color="white" />
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/todopharmaai?igsh=cWFxYTl5MDJvYzBr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram color="white" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
